import {
  Layout,
} from 'antd';
import './ContentContainer.css';



function ContentContainer({ children }) {
  const { Header, Content, Sider } = Layout;

  return (
    <Layout
      className="container"
    >
      <Content
          className="content"
          style={{
            // padding: noPaddingPages.includes(pathname) ? 'unset' : '1rem',
          }}
      >
        {children}
      </Content>
    </Layout>
  );
}

export default ContentContainer;
